import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';

import { NamedLink } from '../../../../components';
import { connect } from 'react-redux';

import SectionContainer from '../SectionContainer';
import css from './SectionHero.module.css';

/**
 * @typedef {Object} FieldComponentConfig
 * @property {ReactNode} component
 * @property {Function} pickValidProps
 */

/**
 * Section component for a website's hero section
 * The Section Hero doesn't have any Blocks by default, all the configurations are made in the Section Hero settings
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {Object} props.defaultClasses
 * @param {string} props.defaultClasses.sectionDetails
 * @param {string} props.defaultClasses.title
 * @param {string} props.defaultClasses.description
 * @param {string} props.defaultClasses.ctaButton
 * @param {string} props.sectionId id of the section
 * @param {'hero'} props.sectionType
 * @param {Object?} props.title
 * @param {Object?} props.description
 * @param {Object?} props.appearance
 * @param {Object?} props.callToAction
 * @param {Object} props.options extra options for the section component (e.g. custom fieldComponents)
 * @param {Object<string,FieldComponentConfig>?} props.options.fieldComponents custom fields
 * @returns {JSX.Element} Section for article content
 */
const SectionHero = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    options,
    currentUser
  } = props;

  const isLoggedIn = !!currentUser;
  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={classNames(rootClassName || css.root)}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={css.heroHeader}>
          <p className={css.eyebrow}>WELCOME TO THE FASHION REVOLUTION</p>
          <Field data={title} className={defaultClasses.title} options={fieldOptions} />
          <Field data={description} className={defaultClasses.description} options={fieldOptions} />
          <div className={css.buttonGroup}>
            {isLoggedIn ? (
              <div className={css.buttonGroup}>
                <NamedLink name="SearchPage" className={classNames(defaultClasses.ctaButton, css.heroCtaButton)}>
                  Browse Items
                </NamedLink>
              </div>

            ) : (
              <Field data={callToAction} className={classNames(defaultClasses.ctaButton, css.heroCtaButton)} options={fieldOptions} />
            )}

          </div>
        </header>
      ) : null}
    </SectionContainer>
  );
};

const mapStateToProps = state => ({

  currentUser: state.user.currentUser,
})

export default connect(mapStateToProps)(SectionHero);


